/* eslint-disable no-param-reassign */
import { AxiosResponse } from 'axios';
import base64 from 'base-64';
import { ParserOutput } from '../../../entities/message-parser-v1/parsed-response';
import {
  getAllLabels,
  getDisplayValue,
  getKeysForFileType,
  hasDisplayValue,
  messageTypeHasStaticDisplay,
} from './display-labelling';

let referenceHolder: any = [];
const nA = 'N/A';
export const getParserDetails = (parsedMessageResponse: AxiosResponse<any>) => {
  const data = parsedMessageResponse.data.parserOutput;
  let parsedDataObject = {};
  data.forEach((datum: ParserOutput) => {
    if (datum.message && datum.message !== 'null') {
      if (datum.contentType === 'application/base-tsf-v0+json')
        parsedDataObject = {
          ...parsedDataObject,
          applicationBaseTsfV0Json: JSON.parse(base64.decode(datum.message)),
        };
      if (datum.contentType === 'application/base-intermediateParsedTSF-v0+json') {
        parsedDataObject = {
          ...parsedDataObject,
          applicationBaseIntermediateTSfV0Json: JSON.parse(base64.decode(datum.message)),
        };
      }
    }
    if (datum.contentType === 'application/xml') {
      parsedDataObject = {
        ...parsedDataObject,
        applicationXml: Buffer.from(datum.message, 'base64').toString('utf8')
      };
    }
  });
  return parsedDataObject;
};
export const convertJsonToTreeTableFormat = (input: any) =>
  Object.keys(input).map((k) => {
    if (!input[k].attributes) {
      if (input[k].children) {
        const subRows: any = Object.keys(input[k].children).map((c) => {
          const object: any = {};
          object[c] = input[k].children[c];
          const a = convertJsonToTreeTableFormat(object);
          return a.length === 1 ? a[0] : a;
        });
        return {
          fieldName: k,
          subRows,
        };
      }
      return {
        fieldName: k,
        hexValue: nA,
        convertedValue: nA,
        displayValue: typeof input[k] === 'object' ? input[k].value : input[k],
      };
    }
    if (input[k].children) {
      const subRows: any = Object.keys(input[k].children).map((c) => {
        const object: any = {};
        object[c] = input[k].children[c];
        const a = convertJsonToTreeTableFormat(object);
        return a.length === 1 ? a[0] : a;
      });
      return {
        fieldName: k,
        hexValue: input[k].attributes.hex,
        convertedValue: input[k].attributes.intermediate,
        subRows,
      };
    }
    return {
      fieldName: k,
      hexValue: input[k].attributes.hex,
      convertedValue: input[k].attributes.intermediate,
      displayValue: input[k].value,
    };
  });

const forceDisplayStaticAttributes = (root: any, fileType: string, key: string, node: any) => {
  root[key] = { children: {} };
  const labels = getAllLabels(fileType, key);
  Object.keys(labels).forEach((label: string) => {
    root[key].children[labels[label]] = { value: 0 };
  });
  if (Array.isArray(node)) {
    let index = 1;
    node.forEach((child) => {
      if (child?.children) {
        const childKey = Object.keys(child.children)[0];
        if (child.children[childKey]) {
          const label = getDisplayValue(
            fileType,
            key,
            child.children[Object.keys(child.children)[0]].value,
            index,
          );
          root[key].children[label] = { value: 1 };
          index += 1;
        }
      }
    });
  } else if (typeof node === 'object' && node?.children) {
    const childKey = Object.keys(node.children)[0];
    if (node.children[childKey]) {
      const label = getDisplayValue(fileType, key, node.children[childKey].value, 1);
      root[key].children[label] = { value: 1 };
    }
  }
};
let addedStaticLabels = false;
export const splitArraysIntoUniqueObjects = (root: any, fileType: string) => {
  const entries = Object.entries(root);
  entries.forEach(([key, value]) => {
    if (hasDisplayValue(fileType, key)) {
      forceDisplayStaticAttributes(root, fileType, key, value);
      addedStaticLabels = true;
    } else {
      if (typeof value === 'object') {
        splitArraysIntoUniqueObjects(root[key], fileType);
      }
      if (Array.isArray(value)) {
        let index = 1;
        value.forEach((child) => {
          if (child.children) root[`${key}-${index}`] = { children: child.children };
          else root[`${key}-${index}`] = { children: child };
          splitArraysIntoUniqueObjects(root[`${key}-${index}`].children, fileType);

          index += 1;
        });
        referenceHolder.push([root, key]);
      }
    }
  });
};

const concernedStructure = (concernedResult: any, fileType: string) => {
  referenceHolder = [];
  if (concernedResult) {
    Object.keys(concernedResult).forEach((k) => {
      if (Array.isArray(concernedResult[k])) {
        splitArraysIntoUniqueObjects(concernedResult, fileType);
      } else {
        splitArraysIntoUniqueObjects(concernedResult[k], fileType);
      }
    });
    if (!addedStaticLabels && messageTypeHasStaticDisplay(fileType)) {
      getKeysForFileType(fileType).forEach((key: string) => {
        forceDisplayStaticAttributes(concernedResult, fileType, key, []);
      });
    }
    referenceHolder.forEach((item: any) => {
      delete item[0][item[1]];
    });
    return convertJsonToTreeTableFormat(concernedResult);
  }
  return '';
}

export const createJSONTree = (result: any, fileType: string) => {
  const concernedResult1 = result['ns1:Message']?.children?.Data?.children || result.Message?.children;
  const concernedResult2 = result['tns:Message']?.children?.Data?.children || result.Message?.children;
  if (concernedResult1) {
    return concernedStructure(concernedResult1, fileType);
  }
  return concernedStructure(concernedResult2, fileType);
};
